import * as React from 'react';
import {Link as RoutedLink} from 'react-router-dom';

import classnames from 'classnames';

import {Illustration} from 'shells/illustrations/illustration';
import {Link} from 'shells/link/link';
import {Body} from 'shells/typography/body';
import {Header} from 'shells/typography/header';

import styles from './pause-page.module.css';

export function PausePage() {
    const header = 'Pause your account';

    const rightLink = (
        // @ts-expect-error
        <Link as={RoutedLink} to='/dashboard'>
            Take me to my dashboard
        </Link>
    );

    return (
        <div className={classnames('pad-16', styles['pause-page'])}>
            <Header>{header}</Header>
            <div className={classnames('flex', styles.body)}>
                <div className={styles.copy}>
                    <Body as='p'>
                        We’re here to support your organization through any unexpected changes.
                    </Body>
                    <Body as='p'>
                        Pause your Nutshell account for just $4/month. We’ll securely retain your
                        contacts and sales data until you’re ready to resume selling.
                    </Body>
                    <div className={styles.buttons}>
                        <Link
                            // @ts-expect-error
                            as={RoutedLink}
                            variant='button-primary'
                            size='xlarge'
                            to='/setup/billing/pause-form'
                        >
                            Pause my account
                        </Link>
                        {rightLink}
                    </div>
                </div>
                <Illustration src='lifeline' width={210} />
            </div>
        </div>
    );
}
